import decode from 'jwt-decode';
import { adalConfig, authContext, endpoint } from './adalConfig';

export default class AADService {
  AADService() {
    return this;
  }
  AADServiceAuthContext() {
    return authContext;
  }
  login() {
    authContext.login();
  }

  loggedIn() {
    return this.getUser() ? true : false;
  }

  logout() {
    authContext.logOut();
  }

  getToken() {
    return authContext.getCachedToken(endpoint);
  }
  async acquireToken() {
    //const a=await authContext.acquireToken(adalConfig.clientId, ()=>{this.getToken()});
    //return(a);
    return authContext.acquireToken(adalConfig.clientId, () => {
      this.getToken();
    });
  }
  registerCallback() {
    return authContext.registerCallback(adalConfig.clientId, token => {
      console.log('token');
    });
  }

  getUser() {
    return authContext.getCachedUser();
  }

  getClaims() {
    return decode(this.getToken());
  }

  getRoles() {
    const claims = this.getClaims();

    if (claims.hasOwnProperty('roles')) {
      return claims.roles;
    }

    return null;
  }

  isInRole(role) {
    if (this.getRoles()) {
      for (var i = 0; i < this.getRoles().length; i++) {
        if (this.getRoles()[i] === role) return true;
      }
    }
    return false;
  }
}
